var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManagement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7CFB\u7EDF-\u914D\u7F6E\u8BBE\u7F6E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "0903\\u4FEE\\u6539",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u8425\\u9500\\u8BA1\\u5212",
    transform: "translate(-4116.000000, -798.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-24\\u5907\\u4EFD",
    transform: "translate(4087.000000, 455.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4\\u5907\\u4EFD-8",
    transform: "translate(12.000000, 332.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7CFB\\u7EDF-\\u914D\\u7F6E\\u8BBE\\u7F6E",
    transform: "translate(17.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,0 L1,0 C0.44771525,0 0,0.44771525 0,1 L0,19 C0,19.5522847 0.44771525,20 1,20 L19,20 C19.5522847,20 20,19.5522847 20,19 L20,1 C20,0.44771525 19.5522847,0 19,0 Z M7,14.2 L6,14.2 L6,15 L4,15 L4,14.2 L3,14.2 L3,12.2 L4,12.2 L4,5 L6,5 L6,12.2 L7,12.2 L7,14.2 L7,14.2 Z M11,15 L9,15 L9,7.8 L8,7.8 L8,5.8 L9,5.8 L9,5 L11,5 L11,5.8 L12,5.8 L12,7.8 L11,7.8 L11,15 Z M17,14.2 L16,14.2 L16,15 L14,15 L14,14.2 L13,14.2 L13,12.2 L14,12.2 L14,5 L16,5 L16,12.2 L17,12.2 L17,14.2 Z",
    id: "\\u5F62\\u72B6",
    fill: "#B5B5C3"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagement);
export default __webpack_public_path__ + "static/media/management.e604bb95.svg";
export { ForwardRef as ReactComponent };